import { getUrl } from './utils'

export const interviews = [
  {
    id: 1,
    text: (
      <p>
        &quot;Правила были довольно простые. Единственное, что мы должны были
        соблюдать, – это основные условия демократической журналистики. То есть
        не пропагандировать войну, не пропагандировать ненависть, в том числе
        расовую, какую угодно ненависть, не разжигать религиозные или другие
        конфликты. Вот и все&quot;. Журналист РС Ефим Фиштейн о том, почему в
        1993-м радио хотели закрыть, как журналисты нашли способ сохранить
        &quot;Свободу&quot; и о том, как впервые услышал на Радио Свобода
        &quot;Архипелаг ГУЛАГ&quot;.
      </p>
    ),
    img: getUrl('/images/videos/3_interviews/interview-1-Efim.jpg'),
    youtube: 'u0anJCtJWV4',
  },
  {
    id: 2,
    text: (
      <p>
        &quot;Одна из проблем отечественной журналистики – это чрезвычайная
        приближенность, вовлеченность в политические и общественно-политические
        процессы. Нельзя организовывать митинг и вечером о нем рассказывать в
        качестве ведущего программы. Это немножко разная работа. И на
        &quot;Свободе&quot; этого не было никогда&quot;. Региональный директор
        Радио Свобода Андрей Шарый – о работе русской службы в кризисных
        ситуациях, о своем опыте работы военным корреспондентом и о том, почему
        Прага – идеальное место для &quot;Свободы&quot;.
      </p>
    ),
    img: getUrl('/images/videos/3_interviews/interview-2-Shary.jpg'),
    youtube: 'jjelsGLbjV0',
  },
  {
    id: 3,
    text: (
      <p>
        &quot;Мы понимаем, что в нынешней ситуации, когда внутри России больше
        не осталось свободной прессы, все свободные издания выехали и работают
        из-за рубежа, мы нужны как никогда. Потому что очень зажато сейчас
        общество, и люди вынуждены опять говорить на кухне. И в такой ситуации
        связь с нами всегда была&quot;. Журналист и бывший директор русской
        службы РС Ирина Лагунина рассказывает о том, как она пришла на радио из
        печатной журналистики и о самых тяжелых моментах истории русской службы.
      </p>
    ),
    img: getUrl('/images/videos/3_interviews/interview-3-Lagunina.jpg'),
    youtube: 'JOA66mDNVuk',
  },
  {
    id: 4,
    text: (
      <p>
        &quot;Исчезновение радио или его закрытие, или медленное удушение – оно
        может погрузить не одну страну в духовную пустыню или пропасть. Поэзия –
        это разговор о жизни и смерти. Поэтому мы сейчас говорим о Радио как о
        виде искусства, и если это вид искусства, значит, этот вид тоже говорит
        о жизни и смерти&quot;. Журналист, поэт и писатель Игорь Померанцев о
        поэтическом анклаве на Радио Свобода, об акустической трагедии ХХ века и
        об интервью с людьми, о жизни которых почти ничего неизвестно.
      </p>
    ),
    img: getUrl('/images/videos/3_interviews/interview-5-Pomerantsev.jpg'),
    youtube: 'slwNF6M794o',
  },
  {
    id: 5,
    text: (
      <p>
        &quot;Политиканы считают, что прошлое не нужно, прошлое ничему не учит,
        из прошлого нельзя вынуть изюминку смысла и истины. А вот я
        придерживаюсь противоположной точки зрения. Для меня в прошлом есть
        масса ответов, примеров этических норм, на которых можно вырасти, и
        которые можно сообщить своим слушателям. И мне страшно нравится
        заниматься этими историческими примерами и аналогиями. Может быть,
        напрямую они не учат, но они заставляют задуматься&quot;. Журналист и
        историк Радио Свобода Иван Толстой рассказывает о пропаганде, которая
        оказалась сильнее людей, о проигравших голосах и о работе с писателями,
        историками и поэтами.
      </p>
    ),
    img: getUrl('/images/videos/3_interviews/interview-4-Tolstoy-inactive.jpg'),
  },
  {
    id: 6,
    text: (
      <p>
        &quot;Мы начинали как радио, а уходя из России, мы были полностью
        мультимедийным, мультиплатформенным медиа. И это все происходило на
        кончиках пальцев. Это исторический момент, если вообще 25 лет можно
        назвать моментом&quot;. Директор русской службы Радио Свобода Евгения
        Назарец о своем первом записанном для РС репортаже о родной деревне
        Павлика Морозова, о ночи убийства Бориса Немцова и о том, как меняется
        аудитория Радио Свобода.
      </p>
    ),
    img: getUrl(
      '/images/videos/3_interviews/interview-6-Nazarets-inactive.jpg'
    ),
  },
]
